/* Layout */
import ClueManage from '@/views/clueManage/index';
import CustomerManage from '@/views/customerManage/index';
import Layout from '@/views/layout/Layout';
const customerManageRouter = {
  path: '/manage/customers',
  component: Layout,
  props: true,
  type: 'sellers',
  redirect: '/manage/customers/list',
  name: 'customerManage',
  meta: {
    title: '客户管理',
    icon: 'customer-management',
    requiresAuth: true,
    role: 'market',
    perms: ['Market.Customer.List']
  },
  hidden: false,
  children: [
    {
      path: 'list',
      name: 'customerList',
      component: CustomerManage,
      meta: {
        title: '客户列表',
        icon: 'customer-management',
        requiresAuth: true,
        role: 'market',
        perms: ['Market.Customer.List']
      },
      hidden: false
    },
    {
      path: 'clue',
      name: 'clueManage',
      component: ClueManage,
      meta: {
        title: '线索管理',
        icon: 'clue-manage',
        requiresAuth: true,
        role: 'market',
        perms: ['Market.BusinessConsult.List']
      },
      hidden: false
    }
  ]
};

export default customerManageRouter;



// WEBPACK FOOTER //
// ./src/router/modules/customerManage.js